export const convertCoordsToPath = (
  coords: Array<readonly [x: number, y: number]>,
  isPoligon = false,
) => {
  return (
    coords.map(([x, y], i) => (i === 0 ? `M ${x} ${y}` : `L ${x} ${y}`)).join(' ') +
    (isPoligon ? ' Z' : '')
  );
};
